module.exports = __webpack_public_path__ + "static/img/1_1_2.5cd9a2b2.jpg";